import CommonLayout from "./CommonLayout";
import React from "react";
import { BadgeOrder } from "../../components/OrderStatus/BadgeOrder";
import moment from "moment/moment";
import ButtonSecondary from "../../shared/Button/ButtonSecondary";
import { useUserSessionStore } from "stores/UserSession.store";
import { useOrders } from "../../hooks/collections/useOrdersV2";
import { useNavigate } from "react-router-dom";
import { Collections } from "../../@core/constants/FirebasePaths";
import { NotFound } from "../../components/NotFound/NotFound";

const AccountProviderOrders = () => {
  const user = useUserSessionStore((state) => state.user);
  const { getReference } = useOrders({ loadData: false });
  const { orders } = useOrders({
    loadData: true,
    queries: [
      {
        type: "where",
        field: "createdBy",
        operator: "==",
        value: getReference(`${Collections.users._path}/${user?.id}`)
      },
      { type: "orderBy", field: "createdAt", direction: "desc" }
    ]
  });
  const navigate = useNavigate();

  const renderSection1 = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div className="flex flex-col md:flex-row gap-5 items-center justify-between">
          <h2 className="text-3xl font-semibold">Provider orders</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className={"overflow-x-auto"}>
          {orders.length ? (
            <table className={"w-full text-left min-w-[1000px] border-separate border-spacing-4"}>
              <thead>
              <tr>
                <th>Service</th>
                <th>Status</th>
                <th>Location</th>
                <th>Date</th>
              </tr>
              </thead>
              <tbody>
              {orders.map((order: any) => (
                <tr key={order.id}>
                  <td>{order.service.title}</td>
                  <td><BadgeOrder status={order.status}/></td>
                  <td>{order.service.details.location.address}</td>
                  <td>{moment(order.reservation.hour, "HH:mm").format("hh:mm A")}, {moment(order.reservation.day, "YYYY-MM-DD").format("MMMM Do, YYYY")}</td>
                  <td>
                    <ButtonSecondary onClick={() => navigate(`/order-detail/${order.id}`)}>View
                      Details</ButtonSecondary>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          ) : (
            <NotFound description={"No orders found for you."} />
          )}
        </div>
      </div>
    );
  };

  return (
    <CommonLayout>{renderSection1()}</CommonLayout>
  );
};

export default AccountProviderOrders;
